module.exports = __webpack_public_path__ + "img/kt01.ee567b70.jpg";